import { Link, type LinkProps, type TypographyProps } from '@mui/material'

export const ButtonLink = (props: LinkProps & Pick<TypographyProps, 'variant'>) => (
  <Link component="button" {...props} />
)

export default ButtonLink
